import { c as _c } from "react/compiler-runtime";
import { logout, useJwtToken, useProfile } from "@website/hooks/auth-manager";
import { MaterialIcon } from "@website/icons/material";
import { USER_TRACKING_EVENTS } from "@website/tracking/tracking.types";
import { addEventToTracking } from "@website/tracking/user";
import { Badge } from "@website/ui/badge";
import { ListItemSizeType } from "@website/ui/list-item";
import { isChannel } from "@website/utils/channel/helpers";
import { numberConvert } from "@website/utils/number-convert";
import { useChatbotVisibility } from "@website/widget/chat-bot/chatbot-experiment";
import { useChatBotNavigation } from "@website/widget/chat-bot/navigation";
import { trackChatbotIconClicked } from "@website/widget/chat-bot/tracking";
import { useSnappPro } from "@website/widget/header/hooks/use-snapp-pro";
import { useRouter } from "next/router";
import { useState } from "react";
import avatarB2B from "../../public/images/avatar-b2b.svg";
import avatar from "../../public/images/avatar.svg";
import { useGetBalance } from "../../services/profile/wallet";
export const useNavbar = () => {
  const $ = _c(113);
  const {
    isLoading,
    data: profile
  } = useProfile();
  const [isCollapsed, setIsCollapsed] = useState(false);
  const {
    profileType,
    role
  } = useJwtToken();
  const {
    hasSnappPro,
    snappProIcon,
    snappProTitle,
    snappProSubTitle
  } = useSnappPro();
  const {
    balance: t0,
    isBalanceError,
    isLoadingGetBalance,
    isSuccess
  } = useGetBalance();
  const {
    balance
  } = t0;
  const router = useRouter();
  const chatBotNavigation = useChatBotNavigation();
  const showChatbot = useChatbotVisibility();
  const isB2BAdmin = role === "corporate.admin" || role === "agency.admin" || role === "admin";
  const hasWallet = !isBalanceError && !isLoadingGetBalance && isSuccess;
  let t1;
  if ($[0] !== hasWallet) {
    t1 = hasWallet && !isChannel(["telesale"]);
    $[0] = hasWallet;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const shouldShowWallet = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = isChannel(["telesale"]);
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const shouldShowMyTrips = !t2;
  const onLogoutClick = _temp;
  let t3;
  if ($[3] !== chatBotNavigation) {
    t3 = () => {
      trackChatbotIconClicked("support_call");
      chatBotNavigation.toggle();
    };
    $[3] = chatBotNavigation;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const handleSupportClick = t3;
  let t4;
  if ($[5] !== profile?.phoneNumber || $[6] !== router) {
    t4 = (pathname, evenetName) => {
      const product = router?.query?.product;
      if (product) {
        const source = router?.query?.source || "profile";
        window?.webengage?.track(evenetName, {
          product,
          "random-usernumber": profile?.phoneNumber?.slice(-1)
        });
        router?.push({
          pathname,
          query: {
            ...router.query,
            ...(source ? {
              source
            } : {}),
            ...(product ? {
              product
            } : {})
          }
        });
      } else {
        router?.push(pathname);
      }
    };
    $[5] = profile?.phoneNumber;
    $[6] = router;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const onClickHandler = t4;
  let t5;
  if ($[8] !== router) {
    t5 = (pathname_0, evenetName_0) => {
      const source_0 = router?.query?.source || "profile";
      window?.webengage?.track(evenetName_0, {
        source: source_0
      });
      addEventToTracking(USER_TRACKING_EVENTS.MY_TRIPS_CLICKED, {
        product: "core"
      });
      router?.push({
        pathname: pathname_0,
        query: {
          ...router.query,
          ...(source_0 ? {
            source: source_0
          } : {}),
          selected_service: "HOTEL"
        }
      });
    };
    $[8] = router;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const onClickMyTripsHandler = t5;
  let t6;
  if ($[10] !== router.pathname) {
    t6 = router.pathname === "/financial-docs" || router.pathname.startsWith("/financial-docs/");
    $[10] = router.pathname;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const isFinancialDocumentsRoute = t6;
  let t7;
  if ($[12] !== balance || $[13] !== onClickHandler) {
    t7 = () => {
      onClickHandler("/wallet", "st-wallet-clicked");
      addEventToTracking(USER_TRACKING_EVENTS.WALLET_CLICKED, {
        wallet_balance: balance,
        product: "core"
      });
    };
    $[12] = balance;
    $[13] = onClickHandler;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  const handleClickOnWallet = t7;
  let t8;
  if ($[15] !== balance || $[16] !== onClickHandler) {
    t8 = () => {
      onClickHandler("/transactions", "st-transactions-clicked");
      addEventToTracking(USER_TRACKING_EVENTS.TRANSACTION_LIST_CLICKED, {
        wallet_balance: balance,
        product: "core"
      });
    };
    $[15] = balance;
    $[16] = onClickHandler;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  const handleClickOnTransaction = t8;
  let t9;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <span>کیف پول</span>;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== balance) {
    t10 = numberConvert(((balance || 0) / 10).toLocaleString(), {
      locale: "fa"
    });
    $[19] = balance;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t10) {
    t11 = <span dir="ltr">{t10}</span>;
    $[21] = t10;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <span>تومان</span>;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t11) {
    t13 = <section className="flex items-center justify-between">{t9}<span className="text-caption text-on-surface-high-emphasis flex gap-1">{t11}{t12}</span></section>;
    $[24] = t11;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  const t14 = router.pathname === "/wallet";
  let t15;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <MaterialIcon name="account_balance_wallet" variant="outlined" />;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== handleClickOnWallet || $[28] !== t13 || $[29] !== t14) {
    t16 = {
      role: "button",
      title: t13,
      selected: t14,
      StartIcon: t15,
      onClick: handleClickOnWallet,
      id: "profile.wallet-button",
      hasNewLabel: false
    };
    $[27] = handleClickOnWallet;
    $[28] = t13;
    $[29] = t14;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  const walletMenu = t16;
  const t17 = router.pathname === "/transactions";
  let t18;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <MaterialIcon name="history" variant="outlined" />;
    $[31] = t18;
  } else {
    t18 = $[31];
  }
  let t19;
  if ($[32] !== handleClickOnTransaction || $[33] !== t17) {
    t19 = {
      role: "button",
      title: "\u0644\u06CC\u0633\u062A \u062A\u0631\u0627\u06A9\u0646\u0634 \u0647\u0627",
      selected: t17,
      StartIcon: t18,
      onClick: handleClickOnTransaction,
      id: "transactions-button",
      hasNewLabel: false
    };
    $[32] = handleClickOnTransaction;
    $[33] = t17;
    $[34] = t19;
  } else {
    t19 = $[34];
  }
  const transactionsMenu = t19;
  let t20;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <MaterialIcon name="insert_chart_outlined" variant="outlined" />;
    $[35] = t20;
  } else {
    t20 = $[35];
  }
  let t21;
  if ($[36] !== router) {
    t21 = () => router?.push("/financial-docs");
    $[36] = router;
    $[37] = t21;
  } else {
    t21 = $[37];
  }
  let t22;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <MaterialIcon name="insert_chart_outlined" variant="outlined" />;
    $[38] = t22;
  } else {
    t22 = $[38];
  }
  let t23;
  if ($[39] !== isFinancialDocumentsRoute || $[40] !== t21) {
    t23 = [{
      role: "button",
      title: "\u0627\u0633\u0646\u0627\u062F \u0645\u0627\u0644\u06CC",
      selected: isFinancialDocumentsRoute,
      onClick: t21,
      id: "financial-docs-button",
      hasNewLabel: false,
      StartIcon: t22
    }];
    $[39] = isFinancialDocumentsRoute;
    $[40] = t21;
    $[41] = t23;
  } else {
    t23 = $[41];
  }
  let t24;
  if ($[42] !== isFinancialDocumentsRoute || $[43] !== t23) {
    t24 = {
      role: "button",
      title: "\u0645\u062F\u06CC\u0631\u06CC\u062A \u0645\u0627\u0644\u06CC",
      selected: isFinancialDocumentsRoute,
      StartIcon: t20,
      id: "financial-management-button",
      hasNewLabel: false,
      subItems: t23
    };
    $[42] = isFinancialDocumentsRoute;
    $[43] = t23;
    $[44] = t24;
  } else {
    t24 = $[44];
  }
  const financialManagementMenu = t24;
  const t25 = router.pathname === "/user-management";
  let t26;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = <MaterialIcon name="perm_contact_calendar" variant="outlined" />;
    $[45] = t26;
  } else {
    t26 = $[45];
  }
  let t27;
  if ($[46] !== router) {
    t27 = () => router?.push("/user-management");
    $[46] = router;
    $[47] = t27;
  } else {
    t27 = $[47];
  }
  let t28;
  if ($[48] !== t25 || $[49] !== t27) {
    t28 = {
      role: "button",
      title: "\u0645\u062F\u06CC\u0631\u06CC\u062A \u06A9\u0627\u0631\u0628\u0631\u0627\u0646",
      selected: t25,
      StartIcon: t26,
      onClick: t27,
      id: "user-management-button",
      hasNewLabel: false
    };
    $[48] = t25;
    $[49] = t27;
    $[50] = t28;
  } else {
    t28 = $[50];
  }
  const userManagementMenu = t28;
  const t29 = router.pathname === "/my-trips";
  let t30;
  if ($[51] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = <MaterialIcon name="luggage" variant="outlined" />;
    $[51] = t30;
  } else {
    t30 = $[51];
  }
  let t31;
  if ($[52] !== onClickMyTripsHandler) {
    t31 = () => {
      onClickMyTripsHandler("/my-trips", "mytrips-clicked");
    };
    $[52] = onClickMyTripsHandler;
    $[53] = t31;
  } else {
    t31 = $[53];
  }
  let t32;
  if ($[54] !== t29 || $[55] !== t31) {
    t32 = {
      role: "button",
      title: "\u0633\u0641\u0631\u0647\u0627\u06CC \u0645\u0646",
      selected: t29,
      StartIcon: t30,
      onClick: t31,
      id: "my-trips-button",
      hasNewLabel: false
    };
    $[54] = t29;
    $[55] = t31;
    $[56] = t32;
  } else {
    t32 = $[56];
  }
  const myTripsMenu = t32;
  let t33;
  if ($[57] !== onClickHandler || $[58] !== profile || $[59] !== profileType || $[60] !== router) {
    t33 = profileType === "B2C" ? {
      role: "button",
      title: <div className="text-xs font-medium">{profile?.fullname || "\u0646\u0627\u0645 \u06A9\u0627\u0631\u0628\u0631\u06CC"}</div>,
      subtitle: <div style={{
        direction: "ltr",
        textAlign: "right"
      }}>{numberConvert(profile?.phoneNumber, {
          locale: "fa"
        })}</div>,
      image: avatar.src,
      selected: router.pathname === "/information",
      size: "x-large" as ListItemSizeType,
      onClick: () => onClickHandler("/information", "st-user-info-clicked"),
      id: "information-button",
      hasNewLabel: false
    } : {
      role: "button",
      title: <div className="text-xs font-medium">{profile?.fullname || "\u0646\u0627\u0645 \u06A9\u0627\u0631\u0628\u0631\u06CC"}</div>,
      overline: <div className="text-secondary text-right text-[10px]">{profile && "company" in profile && profile?.company?.name}</div>,
      subtitle: <div style={{
        direction: "ltr",
        textAlign: "right"
      }}>{numberConvert(profile?.phoneNumber, {
          locale: "fa"
        })}</div>,
      image: avatarB2B.src,
      selected: router.pathname === "/information",
      size: "x-large" as ListItemSizeType,
      onClick: () => router?.push("/information"),
      id: "information-button",
      hasNewLabel: false
    };
    $[57] = onClickHandler;
    $[58] = profile;
    $[59] = profileType;
    $[60] = router;
    $[61] = t33;
  } else {
    t33 = $[61];
  }
  const profileMenu = t33;
  let t34;
  if ($[62] !== hasSnappPro || $[63] !== snappProIcon || $[64] !== snappProSubTitle || $[65] !== snappProTitle) {
    t34 = hasSnappPro ? [{
      title: <div className="flex items-center justify-between"><div className="flex flex-col">{snappProTitle}<div className="text-extra-caption text-on-surface-medium-emphasis">{snappProSubTitle}</div></div><Badge content={"\u0641\u0639\u0627\u0644"} color="success" /></div>,
      StartIcon: <img src={snappProIcon} alt="snapp-pro" />
    }] : [];
    $[62] = hasSnappPro;
    $[63] = snappProIcon;
    $[64] = snappProSubTitle;
    $[65] = snappProTitle;
    $[66] = t34;
  } else {
    t34 = $[66];
  }
  let t35;
  if ($[67] !== shouldShowWallet || $[68] !== walletMenu) {
    t35 = shouldShowWallet ? walletMenu : {};
    $[67] = shouldShowWallet;
    $[68] = walletMenu;
    $[69] = t35;
  } else {
    t35 = $[69];
  }
  const t36 = router.pathname === "/passengers-list";
  let t37;
  if ($[70] === Symbol.for("react.memo_cache_sentinel")) {
    t37 = <MaterialIcon name="people" variant="outlined" />;
    $[70] = t37;
  } else {
    t37 = $[70];
  }
  let t38;
  if ($[71] !== onClickHandler) {
    t38 = () => onClickHandler("/passengers-list", "st-passengers-list-clicked");
    $[71] = onClickHandler;
    $[72] = t38;
  } else {
    t38 = $[72];
  }
  let t39;
  if ($[73] !== t36 || $[74] !== t38) {
    t39 = {
      role: "button",
      title: "\u0644\u06CC\u0633\u062A \u0645\u0633\u0627\u0641\u0631\u0627\u0646",
      selected: t36,
      StartIcon: t37,
      onClick: t38,
      id: "passengers-list-button",
      hasNewLabel: false
    };
    $[73] = t36;
    $[74] = t38;
    $[75] = t39;
  } else {
    t39 = $[75];
  }
  let t40;
  if ($[76] !== isB2BAdmin || $[77] !== userManagementMenu) {
    t40 = isB2BAdmin ? userManagementMenu : {};
    $[76] = isB2BAdmin;
    $[77] = userManagementMenu;
    $[78] = t40;
  } else {
    t40 = $[78];
  }
  let t41;
  if ($[79] !== myTripsMenu) {
    t41 = shouldShowMyTrips ? myTripsMenu : {};
    $[79] = myTripsMenu;
    $[80] = t41;
  } else {
    t41 = $[80];
  }
  const t42 = router.pathname === "/auto-reserve";
  let t43;
  if ($[81] === Symbol.for("react.memo_cache_sentinel")) {
    t43 = <MaterialIcon name="access_time" />;
    $[81] = t43;
  } else {
    t43 = $[81];
  }
  let t44;
  if ($[82] !== onClickHandler) {
    t44 = () => onClickHandler("/auto-reserve", "");
    $[82] = onClickHandler;
    $[83] = t44;
  } else {
    t44 = $[83];
  }
  let t45;
  if ($[84] !== t42 || $[85] !== t44) {
    t45 = {
      role: "button",
      title: "\u062E\u0631\u06CC\u062F\u200C\u0647\u0627\u06CC \u062E\u0648\u062F\u06A9\u0627\u0631",
      selected: t42,
      StartIcon: t43,
      onClick: t44,
      id: "auto-reserve-button",
      hasNewLabel: true
    };
    $[84] = t42;
    $[85] = t44;
    $[86] = t45;
  } else {
    t45 = $[86];
  }
  let t46;
  if ($[87] !== shouldShowWallet || $[88] !== transactionsMenu) {
    t46 = shouldShowWallet ? transactionsMenu : {};
    $[87] = shouldShowWallet;
    $[88] = transactionsMenu;
    $[89] = t46;
  } else {
    t46 = $[89];
  }
  let t47;
  if ($[90] !== financialManagementMenu || $[91] !== isB2BAdmin) {
    t47 = isB2BAdmin ? financialManagementMenu : {};
    $[90] = financialManagementMenu;
    $[91] = isB2BAdmin;
    $[92] = t47;
  } else {
    t47 = $[92];
  }
  let t48;
  if ($[93] !== handleSupportClick || $[94] !== showChatbot) {
    t48 = showChatbot === null ? {
      title: "\u067E\u0634\u062A\u06CC\u0628\u0627\u0646\u06CC",
      StartIcon: <MaterialIcon name="support_agent" />
    } : showChatbot ? {
      role: "button",
      onClick: handleSupportClick,
      title: "\u067E\u0634\u062A\u06CC\u0628\u0627\u0646\u06CC",
      StartIcon: <MaterialIcon name="support_agent" />
    } : {
      role: "link",
      href: "tel:+982192000123",
      title: "\u067E\u0634\u062A\u06CC\u0628\u0627\u0646\u06CC",
      StartIcon: <MaterialIcon name="support_agent" />
    };
    $[93] = handleSupportClick;
    $[94] = showChatbot;
    $[95] = t48;
  } else {
    t48 = $[95];
  }
  let t49;
  if ($[96] === Symbol.for("react.memo_cache_sentinel")) {
    t49 = isChannel(["jek"]) ? {} : {
      role: "button",
      onClick: onLogoutClick,
      title: "\u062E\u0631\u0648\u062C \u0627\u0632 \u062D\u0633\u0627\u0628",
      StartIcon: <MaterialIcon name="logout" />
    };
    $[96] = t49;
  } else {
    t49 = $[96];
  }
  let t50;
  if ($[97] !== profileMenu || $[98] !== t34 || $[99] !== t35 || $[100] !== t39 || $[101] !== t40 || $[102] !== t41 || $[103] !== t45 || $[104] !== t46 || $[105] !== t47 || $[106] !== t48) {
    t50 = [profileMenu, ...t34, t35, t39, t40, t41, t45, t46, t47, t48, t49];
    $[97] = profileMenu;
    $[98] = t34;
    $[99] = t35;
    $[100] = t39;
    $[101] = t40;
    $[102] = t41;
    $[103] = t45;
    $[104] = t46;
    $[105] = t47;
    $[106] = t48;
    $[107] = t50;
  } else {
    t50 = $[107];
  }
  const list = t50;
  let t51;
  if ($[108] !== isCollapsed || $[109] !== isLoading || $[110] !== list || $[111] !== profileType) {
    t51 = {
      list,
      isLoading,
      isCollapsed,
      setIsCollapsed,
      profileType
    };
    $[108] = isCollapsed;
    $[109] = isLoading;
    $[110] = list;
    $[111] = profileType;
    $[112] = t51;
  } else {
    t51 = $[112];
  }
  return t51;
};
function _temp() {
  logout();
  window.location.href = "/";
}